import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 bg-accent-100 text-accent-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            <i className="ri-layout-grid-line text-sm"></i>
            精选推荐
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            热门推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            编辑精选的优质内容，每一篇都值得你花时间深度阅读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cardItems.slice(0, 4).map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="bg-primary-100 text-primary-700 text-xs font-medium px-2 py-0.5 rounded-full">{item.tag}</span>
                  <span className="text-foreground-400 text-xs">{item.time}</span>
                </div>
                <h3 className="text-foreground-950 text-sm font-bold mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-3">
                  {item.summary}
                </p>
                <div className="flex items-center gap-1 text-foreground-400 text-xs">
                  <i className="ri-eye-line"></i>
                  <span>{item.reads} 阅读</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-5">
          {cardItems.slice(4).map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group flex flex-col sm:flex-row"
            >
              <div className="sm:w-40 aspect-[4/3] sm:aspect-auto overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 flex-1 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="bg-primary-100 text-primary-700 text-xs font-medium px-2 py-0.5 rounded-full">{item.tag}</span>
                  <span className="text-foreground-400 text-xs">{item.time}</span>
                </div>
                <h3 className="text-foreground-950 text-sm font-bold mb-1.5 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}